import React from 'react'
import { withIcon } from '../../withIcon'

function FullscreenIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M7 6C6.73478 6 6.48043 6.10536 6.29289 6.29289C6.10536 6.48043 6 6.73478 6 7V9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55228 4 9V7C4 6.20435 4.31607 5.44129 4.87868 4.87868C5.44129 4.31607 6.20435 4 7 4H9C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H7ZM14 5C14 4.44772 14.4477 4 15 4H17C17.7956 4 18.5587 4.31607 19.1213 4.87868C19.6839 5.44129 20 6.20435 20 7V9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9V7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6H15C14.4477 6 14 5.55228 14 5ZM5 14C5.55228 14 6 14.4477 6 15V17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H9C9.55228 18 10 18.4477 10 19C10 19.5523 9.55228 20 9 20H7C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17V15C4 14.4477 4.44772 14 5 14ZM19 14C19.5523 14 20 14.4477 20 15V17C20 17.7957 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7957 20 17 20H15C14.4477 20 14 19.5523 14 19C14 18.4477 14.4477 18 15 18H17C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17V15C18 14.4477 18.4477 14 19 14Z" fill={color}/>
    </svg>
  )
}

export default withIcon(FullscreenIcon)
